import { render, staticRenderFns } from "./gaisuan-list.vue?vue&type=template&id=c7b04bd4&scoped=true"
import script from "./gaisuan-list.vue?vue&type=script&lang=js"
export * from "./gaisuan-list.vue?vue&type=script&lang=js"
import style0 from "./gaisuan-list.vue?vue&type=style&index=0&id=c7b04bd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b04bd4",
  null
  
)

export default component.exports